module.exports = __webpack_public_path__ + "img/chinese.01645436.png";